export default __webpack_public_path__ + "static/logo-db9de544cdd990e1f6e22542da17976b.svg";